export class OneOptionModal {

  static $inject = ["$scope", "$modalInstance", "modalHeader", "modalBody", "modalYes"];

  constructor(
    private $scope: any,
    private $modalInstance: any,
    public modalHeader: string,
    public modalBody: string,
    public modalYes: string,
  ) {
    this.$scope.close = () => this.$modalInstance.dismiss("close");
    this.$scope.yes = () => this.$modalInstance.close("yes");

    this.$scope.modalHeader = modalHeader;
    this.$scope.modalBody = modalBody;
    this.$scope.modalYes = modalYes;
  }
}

angular.module("BookingApp").controller("OneOptionModal", OneOptionModal);
